import React from "react";

export default function Map() {
  return (
    <div
      className="google-map wow fadeInUp"
      data-wow-delay="0.25s"
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <iframe
              title="Simson API Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.6546074876237!2d72.86543177495881!3d19.253878946364708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b18151ad3757%3A0x190e249388e29010!2sSimson%20API!5e0!3m2!1sen!2sin!4v1766569840080!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
